import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import ContentContainer from '../../_common/_containers/ContentContainer/index'

const CourseHeader = props => {
    const {
        title: titleProp,
        image,
        workload,
    } = props


    if (!titleProp)
        return null

    const titleFontSize = titleProp.length > 100 ? '1.4rem' : ''

    const title = workload ? `${titleProp} - ${workload}` : titleProp
    return (


        <ContentContainer className="nrt-course-header"
                          style={{
                              backgroundImage: 'url("' + image + '")'
                          }}
                          center>


            <div className="title-container">
                <h1 style={{
                    fontSize: titleFontSize
                }}>
                    {title}

                </h1>

            </div>


            {/*<DateInterval startDate={startDate} startTime={startTime} endDate={endDate} endTime={endTime} />*/}
            {/*{!!workload && <p className="workload">Carga Horária: {workload}h</p>}*/}
            {/*{!!authorNames && <p className="author">Instrutor(es): {authorNames}</p>}*/}

        </ContentContainer>


    )
}

CourseHeader.propTypes = {
    title: PropTypes.string.isRequired,
    textWidth: PropTypes.any,
    image: PropTypes.string,
    workload: PropTypes.number
}

export default CourseHeader



// WEBPACK FOOTER //
// ./src/components/_courses/CourseHeader/index.js